// Supabase
export const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || '';
export const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

// Legacy Auth0 (will be removed after migration to Supabase Auth)
export const AUTH0_DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN || 'domain';
export const AUTH0_CLIENT_ID = process.env.REACT_APP_AUTH0_CLIENT_ID || 'client_id';
export const AUTH0_API_AUDIENCE = process.env.REACT_APP_AUTH0_AUDIENCE || 'audience';
export const AUTH0_CALLBACK_URI = `${window.location.origin}/home`;

// Legacy API (will be removed after migration to Supabase)
export const API_DOMAIN = process.env.REACT_APP_API_DOMAIN || '';

// Monitoring
export const SENTRY_DNS = process.env.REACT_APP_SENTRY_DSN;
export const ENV = process.env.NODE_ENV;
export const IS_PROD = ENV === 'production';

// Third-party
export const CLOUDINARY_CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME || 'demo';
export const GOOGLE4_MEASUREMENT_ID = process.env.REACT_APP_GOOGLE4_MEASUREMENT_ID || '';

// Feature flags
export const withHiringModule = process.env.REACT_APP_WITH_HIRING_MODULE || false;
export const withInterviewModule = process.env.REACT_APP_WITH_INTERVIEW_MODULE || false;
